import Image from '@react/shared/components/Image';
import MarketingPageTitle from 'sly/hubPage/components/HubDynamicContent/MarketingPageTitle';
import MarketingPageWrapper from 'sly/hubPage/components/MarketingPageWrapper';
import { cx } from 'sly/lib/clsxm';
import { Link } from 'sly/system';

import { GetListWithImg } from '../../HubPage/HubPage.types';

const ListWithImg = ({
  getListWithImg,
}: {
  getListWithImg: GetListWithImg;
}) => {
  return (
    <>
      {!!getListWithImg?.imgWithTitle?.length && (
        <MarketingPageWrapper>
          <MarketingPageTitle title={getListWithImg?.heading} />
          <div
            className={cx(
              'flex gap-l',
              'w-full flex-wrap justify-center',
              'md:justify-between',
              'lg:w-[42.5rem]'
            )}
            data-tp-id='gen-div-5b029d0f-249d-497c-bfff-5f2784d41d7f'
          >
            {getListWithImg?.imgWithTitle?.map((item, index) => (
              <div
                className='basis-[20.5rem] md:basis-[48%]'
                data-tp-id='gen-Block-aec07909-1ce2-46f9-981b-8a74a4b8833f'
                key={item?.id}
              >
                <div
                  className={cx(
                    'rounded-box h-[13.667rem]',
                    item?.backgroundColor && `bg-${item?.backgroundColor}`,
                    'pr-[3.375rem] pt-[3.25rem] pb-[3.167rem] pl-[3.625rem]',
                    'mb-[0.521rem]'
                  )}
                  key={item?.id}
                  data-tp-id='gen-Block-8a8e2662-380c-4b21-8ba8-266884b91f8d'
                >
                  <div
                    className='relative h-full w-full'
                    data-tp-id='gen-div-3ac96242-e3bb-4bc9-b9fa-58e7af1c67c8'
                  >
                    <Image
                      path={item?.srcImg?.path}
                      alt={item?.title}
                      priority={index === 0}
                      loading='eager'
                      objectFit='contain'
                      data-tp-id='gen-Image-e3ce8906-f47c-4f04-9f80-cba2951420e5'
                    />
                  </div>
                </div>
                <div data-tp-id='gen-div-8e13a888-5e2c-4c98-b81f-69d3ffd2ed25'>
                  <p
                    className='font-b-l mb-l text-slate-base'
                    data-tp-id='gen-Paragraph-0990c704-90e2-4f6d-bf80-500f6c1821d9'
                  >
                    {item?.title}
                  </p>
                </div>
              </div>
            ))}
            {getListWithImg?.buttonText && getListWithImg?.buttonUrl && (
              <Link
                className={cx(
                  'h-full w-full bg-viridian-base',
                  'rounded-box text-white',
                  'text-center no-underline',
                  'py-s px-l',
                  'cursor-pointer hover:bg-viridian-darker-20 hover:no-underline',
                  'active:bg-viridian-darker-40'
                )}
                to={getListWithImg?.buttonUrl}
                data-tp-id='gen-Link-5e08e799-fe25-4aa1-bcb6-f5d8c71592c9'
              >
                {getListWithImg?.buttonText}
              </Link>
            )}
          </div>
        </MarketingPageWrapper>
      )}
    </>
  );
};

export default ListWithImg;
